import { PropsWithChildren, ReactNode } from 'react';
import { Accordion as ReactAccordion, Card } from 'react-bootstrap';

import { AccordionHeader } from './AccordionHeader';
import classNames from 'classnames';

interface Props {
  eventKey: string;
  header: ReactNode | (() => ReactNode);
  showIcon?: boolean;
  defaultExpanded?: boolean;
  classes?: {
    card?: string;
    header?: string;
    body?: string;
  };
}

export const Accordion = ({
  children,
  eventKey,
  header,
  showIcon = true,
  defaultExpanded,
  classes,
}: PropsWithChildren<Props>) => {
  return (
    <ReactAccordion
      defaultActiveKey={defaultExpanded ? eventKey : undefined}
      className="tw:w-full"
    >
      <Card
        className={classNames('accordion--card tw:w-full', classes?.card)}
        style={{ backgroundColor: 'var(--neutral-800)' }}
      >
        <AccordionHeader
          eventKey={eventKey}
          hasIcon={showIcon}
          className={classes?.header}
        >
          {typeof header === 'function' ? header() : header}
        </AccordionHeader>

        <ReactAccordion.Collapse eventKey={eventKey}>
          <Card.Body
            className={classNames(classes?.body)}
            // previously p-0 was in className,
            // but we cannot overwrite a padding class with a "lower" padding class because bootstrap applies !important to all padding classes
            // instead we use style as the default, then overwrite with className
            // libs like tailwind-merge handle conflicting css classname resolution by letting the last class win
            style={{
              padding: 0,
            }}
          >
            {children}
          </Card.Body>
        </ReactAccordion.Collapse>
      </Card>
    </ReactAccordion>
  );
};
